export default "__VITE_ASSET__17i6Kp8Q__"